import {ISeriesContentPage} from "@montana/models/generated/cms.interface";
import React from "react";
import {Container} from "@montana/shared/container";
import {DynamicBlocks} from "@montana/blocks/dynamic-blocks.component";

export function SeriePage(props: ISeriesContentPage) {

    const { blocks } = props;

    return (
        <Container>
            <DynamicBlocks blocks={blocks} isFirstElementOnPage />
        </Container>
    );
}